import DomainEntity from '@/models/DomainEntity'

export default class StateLoans extends DomainEntity {
  static get collectionName() {
    return 'stateloans/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      items: {},
    }
  }
}
